import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);
export const router = new Router({
  mode: 'history',
  // base: process.env.NODE_ENV == 'development' ? '/' : '/cxeditor/',
  base:
    process.env.NODE_ENV === 'production:tolan'
      ? '/cxeditor/'
      : process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'production:topre'
      ? '/editblog/' // topub
      : '/',
  routes: [
    { path: '/', redirect: '/articleManage.html' },
    {
      path: '/richTextEditor.html',
      name: 'RichTextEditor',
      meta: {
        title: '财新博客',
      },
      component: () => import(/* webpackChunkName: 'blogEditor' */ '@/routes/RichTextEditor.vue'),
    },
    {
      path: '/articleManage.html',
      name: 'ArticleManage',
      meta: {
        title: '文章管理',
      },
      component: () => import(/* webpackChunkName: 'blogManage' */ '@/routes/ArticleManage.vue'),
    },
    {
      path: '/topicManage.html',
      name: 'TopicManage',
      meta: {
        title: '话题管理',
      },
      component: () => import(/* webpackChunkName: 'blogManage' */ '@/routes/TopicManage.vue'),
    },
    {
      path: '/classification.html',
      name: 'Classification',
      meta: {
        title: '个人分类',
      },
      component: () => import(/* webpackChunkName: 'blogManage' */ '@/routes/Classification.vue'),
    },
    {
      path: '/addBlogUser.html',
      name: 'AddBlogUser',
      meta: {
        title: '添加博主',
      },
      component: () => import(/* webpackChunkName: 'blogManage' */ '@/routes/AddBlogUser.vue'),
    },
    {
      path: '/blogUserList.html',
      name: 'BlogUserList',
      meta: {
        title: '博主列表',
      },
      component: () => import(/* webpackChunkName: 'blogManage' */ '@/routes/BlogUserList.vue'),
    },
    {
      path: '/sensitiveWordsManage.html',
      name: 'SensitiveWordsManage',
      meta: {
        title: '敏感词管理',
      },
      component: () => import(/* webpackChunkName: 'blogManage' */ '@/routes/SensitiveWordsManage.vue'),
    },
    { path: '*', redirect: '/articleManage.html' },
  ],
});
router.beforeEach(function(to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
